import { Check, ChevronLeft, Business } from '@mui/icons-material'
import { FormProvider } from 'react-hook-form'
import { Button } from 'ui'
import { FormInputText } from 'feature/formComponents'
import { AddressSelectInput } from 'widget/AddressSelectInput'
import { LoaderInCentalPosition } from 'widget'

import { useCompanyEditProfile } from './useCompanyEditProfile'
import { COMPANY_EDIT_SECTIONS } from './companyEditFields'
import style from './CompanyEditProfile.module.scss'
import { EditPagesHead } from 'ui/EditPagesHead/EditPagesHead'

export type CompanyEditFormValues = {
  firstName: string
  lastName: string
  fatherName: string
  companyName: string
  kpp: string
  ogrn: string
  directorFullName: string
  directorPosition: string
}

export function CompanyEditProfile() {
  const {
    formMethods,
    isLoading,
    isUpdating,
    isDirty,
    isValid,
    onSubmit,
    navigate,
  } = useCompanyEditProfile()

  if (isLoading) return <LoaderInCentalPosition />

  return (
    <FormProvider {...formMethods}>
      <div className='container'>
        <EditPagesHead
          Icon={<Business color='primary' />}
          title='Редактирование профиля'
          button={{
            startIcon: <ChevronLeft />,
            onClick: () => navigate('/settings'),
            text: 'Назад',
          }}
        />

        <form
          className={style.editForm}
          noValidate
          onSubmit={e => {
            e.preventDefault()
            onSubmit()
          }}
        >
          {COMPANY_EDIT_SECTIONS.map(section => (
            <div key={section.title} className={style.editForm__section}>
              <span className='h4'>{section.title}</span>

              {section.fields.map(
                ({
                  name,
                  label,
                  required,
                  numericOnly,
                  allowAllChars,
                  maxLength,
                }) => (
                  <FormInputText
                    key={name}
                    name={name}
                    numericOnly={numericOnly}
                    allowAllChars={allowAllChars}
                    inputProps={{
                      label,
                      required,
                      ...(maxLength && { inputProps: { maxLength } }),
                    }}
                  />
                ),
              )}
            </div>
          ))}

          <div className={style.editForm__section}>
            <span className='h4'>Адреса</span>
            <AddressSelectInput
              label='Юридический адрес'
              name='legalAddress'
              addressKey='default'
              inputProps={{
                inputProps: { 'data-testid': 'company-edit-legal-address' },
              }}
            />
            <AddressSelectInput
              label='Фактический адрес'
              name='actualAddress'
              addressKey='company'
              inputProps={{
                inputProps: { 'data-testid': 'company-edit-actual-address' },
              }}
            />
          </div>

          <Button
            type='submit'
            startIcon={<Check />}
            disabled={!isDirty || !isValid || isUpdating}
            size='medium'
            variant='contained'
            data-testid='company-edit-submit'
          >
            {isUpdating && <LoaderInCentalPosition />}
            Сохранить изменения
          </Button>
        </form>
      </div>
    </FormProvider>
  )
}
